import CustomImageComponent from '../custom/custom-image';

const RuletaFantasyIcon = ({ size }) => {
    return (
        <CustomImageComponent
            src={`${process.env.NEXT_PUBLIC_IMAGES}/logos/ruleta-fantasy.png?${size * 1.5}`}
            alt="logo"
            width={size ?? 20}
            height={size ?? 20}
            priority={true}
        />
    );
};

export default RuletaFantasyIcon;
